import React from "react"
import Title from "./Title"
import educationItems from "../constants/education-items"
import '../css/timeline.css'

const Education = () => {
    
  return <section className="section bg-white">
    <Title title="Education history" />
    <div className="section-center timeline-center">
    {
        educationItems.map((item =>{
            const {id, date, title, text} = item
            return <article key={id} className="timeline-item">
                <h4>{date}</h4>
                <h4>{title}</h4>
                <p>{text}</p>
                <span className="number">{id}</span>
            </article>

        }))
    }
    </div>
    </section>
}

export default Education